<app-sv-test-panel-info-panel [panel]="selectedPanel" [isOpen]="isInfoPanelOpen" (closed)="onInfoPanelClosed()" />

<div class="sub-container">
  <div class="d-flex">
    <app-table-search (filterChanged)="onFilterChanged($event)"></app-table-search>
    <app-buttons
      style="margin-left: 15px"
      [isDisabled]="selectedPanelItems.length === 0"
      [name]="btnNameShare"
      [buttonType]="btnMatFlat"
      [buttonStyle]="
        selectedPanelItems.length === 0 ? btnStyleFilledSmallForPrimaryBtnDisabled : btnStyleFilledSmallForPrimaryBtn
      "
      (buttonClickEvent)="onShareClicked()"
    >
    </app-buttons>
  </div>
  <app-buttons
    [isDisabled]="false"
    [name]="btnName"
    [buttonType]="btnMatStroked"
    [buttonStyle]="btnStyleStroked"
    (buttonClickEvent)="openFileUploadModal()"
  >
  </app-buttons>
</div>
<app-table
  [displayedColumnLabels]="displayedColumnLabels"
  [displayedColumns]="displayedColumns"
  [dataSource]="dataSource"
  [showActionColumn]="showActionColumn"
  [showMenuButton]="true"
  [showDeleteButton]="false"
  [showEditMenuItem]="true"
  [showDownloadButton]="false"
  [showTestIconButton]="false"
  [isSvTestPanelTab]="true"
  [showCheckbox]="showCheckboxInTable"
  [firstColumnClickable]="true"
  [isRowActive]="isRowActiveFn"
  (firstColumnClicked)="handleGetInfoClick($event.data)"
  (rowMenuOpened)="onRowMenuOpened($event)"
  (rowMenuClosed)="onRowMenuClosed()"
  (onRunMenuButtonClicked)="onRunBtnClicked($event)"
  (onDeleteMenuButtonClicked)="deletePanel($event)"
  (downloadClicked)="downloadPanel($event)"
  (onSampleEditButtonClicked)="handleSvTestEditClick($event)"
  (onGetInfoMenuButtonClicked)="handleGetInfoClick($event)"
  (onDownloadResultMenuButtonClicked)="handleDownloadClick($event)"
  (checkboxChanged)="handleCheckboxChange($event)"
>
</app-table>
